<template>
  <div>
    <!--<b>#{{item.id}}</b>-->
    <span>{{ item.name }}</span>
  </div>
</template>

<script>
export default {
  props: {
    item: { required: true },
    searchText: { required: true }
  }
}
</script> 



// WEBPACK FOOTER //
// src/components/procedure/item-template.vue